export const GET_QUOTA_USAGE = 'recordings::GET_QUOTA_USAGE';
export const GET_QUOTA_USAGE_SUCCESS = 'recordings::GET_QUOTA_USAGE_SUCCESS';
export const GET_QUOTA_USAGE_FAILURE = 'recordings::GET_QUOTA_USAGE_FAILURE';

export const SCHEDULE_RECORDING = 'recordings::SCHEDULE_RECORDING';
export const SCHEDULE_RECORDING_SUCCESS =
    'recordings::SCHEDULE_RECORDING_SUCCESS';
export const SCHEDULE_RECORDING_FAILURE =
    'recordings::SCHEDULE_RECORDING_FAILURE';

export const SCHEDULE_SERIES_RECORDING =
    'recordings::SCHEDULE_SERIES_RECORDING';
export const SCHEDULE_SERIES_RECORDING_SUCCESS =
    'recordings::SCHEDULE_SERIES_RECORDING_SUCCESS';
export const SCHEDULE_SERIES_RECORDING_FAILURE =
    'recordings::SCHEDULE_SERIES_RECORDING_FAILURE';

export const DELETE_RECORDING = 'recordings::DELETE_RECORDING'; // delete and cancel use the same api
export const DELETE_RECORDING_SUCCESS = 'recordings::DELETE_RECORDING_SUCCESS';
export const DELETE_RECORDING_FAILURE = 'recordings::DELETE_RECORDING_FAILURE';

export const CANCEL_RECORDING = 'recordings::CANCEL_RECORDING';
export const CANCEL_RECORDING_SUCCESS = 'recordings::CANCEL_RECORDING_SUCCESS';
export const CANCEL_RECORDING_FAILURE = 'recordings::CANCEL_RECORDING_FAILURE';

export const DELETE_SERIES_RECORDING = 'recordings::DELETE_SERIES_RECORDING';
export const DELETE_SERIES_RECORDING_SUCCESS =
    'recordings::DELETE_SERIES_RECORDING_SUCCESS';
export const DELETE_SERIES_RECORDING_FAILURE =
    'recordings::DELETE_SERIES_RECORDING_FAILURE';

export const CANCEL_SERIES_RECORDING = 'recordings::CANCEL_SERIES_RECORDING';
export const CANCEL_SERIES_RECORDING_SUCCESS =
    'recordings::CANCEL_SERIES_RECORDING_SUCCESS';
export const CANCEL_SERIES_RECORDING_FAILURE =
    'recordings::CANCEL_SERIES_RECORDING_FAILURE';

export const PROTECT_RECORDING = 'recordings::PROTECT_RECORDING';
export const PROTECT_RECORDING_SUCCESS =
    'recordings::PROTECT_RECORDING_SUCCESS';
export const PROTECT_RECORDING_FAILURE =
    'recordings::PROTECT_RECORDING_FAILURE';

export const UNPROTECT_RECORDING = 'recordings::UNPROTECT_RECORDING';
export const UNPROTECT_RECORDING_SUCCESS =
    'recordings::UNPROTECT_RECORDING_SUCCESS';
export const UNPROTECT_RECORDING_FAILURE =
    'recordings::UNPROTECT_RECORDING_FAILURE';

export const UNFOCUS_RECORDING = 'recordings::UNFOCUS_RECORDING';

export const GET_RECORDINGS_CACHE = 'recordings:GET_RECORDINGS_CACHE';
export const GET_RECORDINGS_CACHE_REQUEST =
    'recordings:GET_RECORDINGS_CACHE_REQUEST';
export const GET_RECORDINGS_CACHE_SUCCESS =
    'recordings:GET_RECORDINGS_CACHE_SUCCESS';
export const GET_RECORDINGS_CACHE_FAILURE =
    'recordings:GET_RECORDINGS_CACHE_FAILURE';

export const SET_DELETE_ACTION_PIN_VALIDATION_TIME =
    'recordings:SET_DELETE_ACTION_PIN_VALIDATION_TIME';
